import React from 'react';
import { IconButton, InputAdornment } from '@ha/dsl';
import VisibilityIcon from 'streamline-icons/bold/view-1.svg';
import VisibilityOffIcon from 'streamline-icons/view-off.svg';
import TextField from 'ha/components/next/FormFields/TextField';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import { makeStyles } from '@material-ui/core';

interface Props {
  id?: string;
  label?: string;
  required?: boolean;
  error?: boolean | undefined;
  input: WrappedFieldInputProps;
  meta: WrappedFieldMetaProps;
}

const useStyles = makeStyles(() => ({
  passwordIcon: {
    position: 'absolute',
    right: 0,
  },
}));

const PasswordField: React.FC<Props> = props => {
  const [showPassword, setShowPassword] = React.useState(false);
  const { passwordIcon } = useStyles();

  return (
    <TextField
      variant="standard"
      type={showPassword ? 'text' : 'password'}
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" classes={{ root: passwordIcon }}>
            <IconButton
              aria-label="Toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
